import { UsersTypeEnum } from "@monta/utils";

export const getUserTypeName = (id?: UsersTypeEnum) => {
  if (!id) return;
  switch (id) {
    case UsersTypeEnum.STUDENT:
      return "دانش آموز";
    case UsersTypeEnum.ADVISOR:
      return "مشاور";
    case UsersTypeEnum.TEACHER:
      return "دبیر";
    case UsersTypeEnum.ADMINISTRATOR:
      return "ادمین";
    case UsersTypeEnum.مرکز_مشاوره:
      return "مرکز مشاوره";
    case UsersTypeEnum.DEAN:
      return "مدرسه";
    case UsersTypeEnum.آموزشگاه:
      return "آموزشگاه";
    case UsersTypeEnum.PARENT:
      return "والدین";
    case UsersTypeEnum.PUBLISHER:
      return "انتشارات";
    case UsersTypeEnum.SALES_EXPERT:
      return "کارشناس فروش";
    case UsersTypeEnum.SALES_MANAGER:
      return "مدیر فروش";
    case UsersTypeEnum.SDR:
      return "(SDR) کارشناس توسعه فروش";
    case UsersTypeEnum.AM:
      return "(AM)مدیر اکانت";
  }
};
